// impersonationStore.ts
import { persistentAtom } from "@nanostores/persistent";
import { useStore } from "@nanostores/react";

// Persistent atom in localStorage with a key
const $impersonatedUserEmailStore = persistentAtom<string | null>(
  "impersonatedUserEmail", // localStorage key
  null, // default value
  {
    encode: JSON.stringify,
    decode: JSON.parse,
  },
);

const useImpersonatedUserEmail = () => useStore($impersonatedUserEmailStore);

// Getter
const getImpersonatedUserEmail = () => {
  return $impersonatedUserEmailStore.get();
};

// Setter
const setImpersonatedUserEmail = (email: string | null) => {
  $impersonatedUserEmailStore.set(email);
};

export {
  useImpersonatedUserEmail,
  getImpersonatedUserEmail,
  setImpersonatedUserEmail,
};
